import React from 'react'
import './NavbarMobile.css'
import { BiHomeSmile } from 'react-icons/bi'
import { AiOutlineUser, AiOutlineShop } from 'react-icons/ai'
import { PiArticle } from 'react-icons/pi'
import { HiOutlineShoppingBag } from 'react-icons/hi2'
import { NavLink } from 'react-router-dom'
import { isLoggedIn } from '../../Hooks/isLoggedIn'
export default function NavbarMobile() {
    return (
        <div className="navbar-mobile">
            <div className="navbar-mobile-icon">
                <NavLink to='/cart'>
                    <HiOutlineShoppingBag />
                </NavLink>
            </div>
            <div className="navbar-mobile-icon">
                <NavLink to='/courses'>
                    <AiOutlineShop />
                </NavLink>
            </div>
            <div className="navbar-mobile-icon">
                <NavLink to='/'>
                    <BiHomeSmile />
                </NavLink>
            </div>
            <div className="navbar-mobile-icon">
                <NavLink to='/articles'>
                    <PiArticle />
                </NavLink>
            </div>
            <div className="navbar-mobile-icon">
                {
                    isLoggedIn() ? (
                        <NavLink to='/userpanel'>
                            <AiOutlineUser />
                        </NavLink>
                    ) : (
                        <NavLink to='/login'>
                            <AiOutlineUser />
                        </NavLink>
                    )
                }

            </div>
        </div>
    )
}
